import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby';

const Testimonials = () => {
  return (
<section className="bg-white py-24 sm:py-32">
  <div className="mx-auto max-w-7xl px-6 lg:px-8">
    <div className="mx-auto grid max-w-2xl grid-cols-1 lg:mx-0 lg:max-w-none lg:grid-cols-2">
      <div className="flex flex-col pb-10 sm:pb-16 lg:pb-0 lg:pr-8 xl:pr-20">
      <StaticImage
          src="../images/logos/fortra_logo_dark.webp"
          alt="Fortra"
          objectFit="contain"
          width="218"
          height="40"
          className="h-10 self-start"
        />
        <figure className="mt-10 flex flex-auto flex-col justify-between">
          <blockquote className="text-xl leading-8 text-gray-950 lg:text-2xl lg:leading-10">
            <p>“Fortra's use of Sorry™ allows us to easily create designated pages for tracking announcements specific to each product.”</p>
          </blockquote>
          <div className="mt-4 font-semibold text-gray-600 underline underline-offset-2 hover:text-gray-900"><Link to="/testimonials/20240723-fortra-cybersecurity-status/">Read the story &rarr;</Link></div>
          <figcaption className="mt-10 flex items-center gap-x-6">
            <div className="text-base">
              <div className="font-semibold text-gray-900">Ollie Peacey</div>
              <div className="mt-1 text-gray-500">Incident Response Manager, Fortra</div>
            </div>
          </figcaption>
        </figure>
      </div>
      <div className="flex flex-col border-t border-gray-900/10 pt-10 sm:pt-16 lg:border-l lg:border-t-0 lg:pl-8 lg:pt-0 xl:pl-20">
      <StaticImage
          src="../images/logos/postmark_logo_dark.webp"
          alt="Fortra"
          objectFit="contain"
          width="218"
          height="40"
          className="h-10 self-start"
        />
        <figure className="mt-10 flex flex-auto flex-col justify-between">
          <blockquote className="text-xl leading-8 text-gray-950 lg:text-2xl lg:leading-10">
            <p>“Recognising the need for improvement, we swiftly decided to go with Sorry™ to enhance our communication capabilities.”</p>
          </blockquote>
          <div className="mt-4 font-semibold text-gray-600 underline underline-offset-2 hover:text-gray-900 "><Link to="/testimonials/20240910-postmark-email-delivery-status/">Read the story &rarr;</Link></div>
          <figcaption className="mt-10 flex items-center gap-x-6">
            <div className="text-base">
              <div className="font-semibold text-gray-900">Trevor Rawls</div>
              <div className="mt-1 text-gray-500">Marketing, ActiveCampaign</div>
            </div>
          </figcaption>
        </figure>
      </div>
    </div>
  </div>
</section>
  
  )
}

export default Testimonials